import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { merge } from 'lodash';
import { Material } from '../material/styles/Material';
import { colors } from '../styles/colors';
import { colors as colorsDark } from '../styles/colorsDark';
import { Global, Props } from '../styles/Global';
import { PartialTheme } from '../styles/theme';
const ThemeContext = React.createContext(colors);
export function useTheme() {
  return React.useContext(ThemeContext);
}

/**
 * @deprecated use this instead: import { ThemeProvider } from '@cntxt/shared/ui/mui-theme';
 */
export const StyleProvider: React.FC<React.PropsWithChildren<{
  theme?: Props['themeName'];
  themeExtensions?: PartialTheme;
}>> = t0 => {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    theme,
    themeExtensions,
    children
  } = t1;
  const chosenTheme = theme === "dark" ? colorsDark : colors;
  let t2;
  if ($[2] !== chosenTheme || $[3] !== themeExtensions) {
    t2 = merge(chosenTheme, themeExtensions);
    $[2] = chosenTheme;
    $[3] = themeExtensions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const extendedTheme = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CssBaseline />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = theme || "light";
  let t5;
  if ($[6] !== extendedTheme || $[7] !== t4) {
    t5 = <Global themeName={t4} theme={extendedTheme} />;
    $[6] = extendedTheme;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Material />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children || $[11] !== extendedTheme || $[12] !== t5) {
    t7 = <ThemeContext.Provider value={extendedTheme}>{t3}{t5}{t6}{children}</ThemeContext.Provider>;
    $[10] = children;
    $[11] = extendedTheme;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};